import { formatStatus, statusBadgeClass } from '../screens/ordersUtils'

type StatusPillProps = {
  status: string
  label?: string
  className?: string
}

export const StatusPill = ({ status, label, className }: StatusPillProps) => (
  <span className={[statusBadgeClass(status), className].filter(Boolean).join(' ')}>
    {label ?? formatStatus(status)}
  </span>
)
